$(function () {
	/* Open all PDF links in a new window */
	$('a[href$=".pdf"]').attr('target', '_blank');
	/* Breadcrumb */
	$(".ly-breadcrumb span a:last, .ly-breadcrumb span:last").addClass("last");
	$(".ly-breadcrumb span .ly-breadcrumb-link:nth-last-child(3)").addClass("second-last");
	$(".ly-breadcrumb").toggleClass("ly-breadcrumb-shortened", $(".ly-breadcrumb-link").length > 2);
	$(".ly-breadcrumb-trigger").click(function () {
			$(".ly-breadcrumb").toggleClass("ly-breadcrumb-shortened");
 });
  
	/* Mobile Navigation */
	$('.ly-hamburger').on("click", () => {
		// $('.ly-hamburger').toggleClass('open');
    $('#nav-mobile').toggleClass('open');
		$('body').toggleClass('ly-disablescroll');
	});

	
	$('#nav-mobile .ly-navopener').on('click', () => {
		if(!$(event.currentTarget).parent().parent().hasClass('ly-active')) {
			if(!$(event.currentTarget).parents('.has-child').hasClass('ly-active')) {
				$('.ly-active').find('ul:first').slideUp();
				$('.ly-active').removeClass('ly-active');
			}
			$(event.currentTarget).parent().parent().toggleClass('ly-active').find('ul:first').slideDown();
		} else {
			$(event.currentTarget).parent().parent().toggleClass('ly-active').find('ul:first').slideUp();
		}
	});


	/* Desktop Navigation */
	$('.ly-nav-sub .ly-navopener').on('click', () => {
		if(!$(event.currentTarget).parent().parent().hasClass('ly-active')) {
			if(!$(event.currentTarget).parents('.has-child').hasClass('ly-active')) {
				$('.ly-active').find('ul:first').slideUp();
				$('.ly-active').removeClass('ly-active');
			}
			$(event.currentTarget).parent().parent().toggleClass('ly-active').find('ul:first').slideDown();
		} else {
			$(event.currentTarget).parent().parent().toggleClass('ly-active').find('ul:first').slideUp();
		}
	});


		/* mailencrypting */
	setTimeout(() => {
		$('[data-madr1]').not('.madr-done').each((i, item) => {
			const mailLinkElem = $(item);
			const maddr = mailLinkElem.attr('data-madr1') + '@' + mailLinkElem.attr('data-madr2') + '.' + mailLinkElem.attr('data-madr3');
			const linktext = mailLinkElem.attr('data-linktext') ? mailLinkElem.attr('data-linktext') : maddr;
			mailLinkElem.after('<a href="mailto:' + maddr + '">' + linktext + '</a> ');
			mailLinkElem.addClass('madr-done').hide();
		})
	}, 500);

	


	/*Find Word exclusiv and change Color*/
	// var yourstring="exclusiv";
	// $('#content p:contains('+yourstring+')', document.body).not('#content a:contains('+yourstring+')').each(function(){
	// 	$(this).html($(this).html().replace(
	// 				new RegExp(yourstring, 'g'), '<span class=text-primary>'+yourstring+'</span>'
	// 	));
	// }​);
​

	/* Go to top button */
	$('.ly-top').on('click', () => {
		$("html, body").animate({
			scrollTop: 0
		}, 1200);
		return false;
	});
	 
	// Check if DNN < 9
	if ($("body.role-admin").length > 0) {
		if ($(".personalBarContainer").length > 0) {
			$("header").css("margin-top", "0");
		}
	}

	$(window).scroll(() => {
		if ($(this).scrollTop() > 200) {
			$('.ly-top').addClass('ly-top-visible');
		} else {
			$('.ly-top').removeClass('ly-top-visible');
		}
	});

		// Replace $ in Sub-Navigation with <br/>
		// // var links = $(".ly-nav-sub a:contains('¶')");
		// // links.each(function() {
		// // 	var $this = $(this);
		// // 	$this.html($this.html().replace(/¶/g, '<br/>'));
		// // });
	
		// Replace $ in Title and BreadCrumb with Space
		$(".ly-breadcrumb a:contains('¶'),title").each(function() {
			var $this = $(this);
			$this.text($this.text().replace(/¶/g, ' - '));
		});

	// Sticky header
	var navheight = $('header').height();
	$(window).scroll(() => {
		if ($(window).scrollTop() >= navheight +40) {
			$('header').addClass('fixed-header');
		
			if ($(window).scrollTop() >= navheight + 41) {
				$('header').addClass('fixed-top');
			}
		} else {
			$('header').removeClass('fixed-header fixed-top');
			$('body').css('padding-top', '40px');
		}
	});
});